import React, { useState, useEffect } from 'react';
import { bool, shape, string } from 'prop-types';
import {
  bool as boolType, extend,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { Image } from '@thd-olt-component-react/image';
import { useDataModel } from '@thd-nucleus/data-sources/react/dataModel/useDataModel';
import { Col, Row } from '@thd-olt-component-react/grid';
import './returns-messaging.scss';

const ReturnsMessaging = ({ itemId }) => {
  const ICON_HEIGHT = '25';
  const ICON_WIDTH = '32';

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('returns-messaging.ready'); }, []);

  const { data, loading, error } = useDataModel('product', { variables: { itemId } });
  if (loading || (error && !data) || data?.product?.info?.returnable === 'Non-Returnable') {
    return null;
  }

  return (

    <Col className="returns-messaging">
      <div className="returns-messaging__wrapper">
        <Image
          asset="returns.svg"
          alt="icon"
          className="returns-messaging__icon"
          height={ICON_HEIGHT}
          width={ICON_WIDTH}
        />
        <div id="buybox">
          <div className="returns-messaging__title">
            Easy Returns In Store and Online
          </div>
          Read our
          <a
            href="https://www.homedepot.com/c/Return_Policy"
            target="_blank"
            rel="noopener noreferrer"
            className="returns-messaging__link"
          >
            Return Policy
          </a>
        </div>
      </div>
    </Col>
  );
};

ReturnsMessaging.displayName = 'ReturnsMessaging';

ReturnsMessaging.dataModel = extend({
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    info: shapeType({
      returnable: stringType()
    })
  }),
});

ReturnsMessaging.propTypes = {
  itemId: string.isRequired
};

export { ReturnsMessaging };
